import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Icons from "material-ui-next/Icon";

import { Loadable, StyledButton } from "components/support";

import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui-next/Dialog";
import Subheader from "material-ui/Subheader";

import ConfigField from "../config";

class CustomInfoModal extends Component {
  static FieldType = [
    { label: "Texto Simples", value: "simple_text" },
    { label: "Texto Grande", value: "large_text" },
    { label: "Telefone", value: "phone" },
    { label: "Data", value: "date" },
    { label: "Hora", value: "hour" },
    { label: "Data e Hora", value: "datetime" },
    { label: "Lista", value: "list" },
    { label: "Radio Button", value: "radiobutton" }
  ];

  render() {
    const { visible, presenter, viewModel } = this.props;
    const { loading, fields } = viewModel;

    return (
      <Dialog
        open={visible}
        onClose={() => presenter.onClose()}
        disableBackdropClick={true}
        fullWidth={true}
        maxWidth={"md"}
      >
        <Loadable loading={loading}>
          <DialogTitle>Gerenciar Campos</DialogTitle>

          <DialogContent>
            <Subheader
              style={{ lineHeight: "20px", padding: "0px 0px 10px 0px" }}
            >
              * Os campos cadastrados estarão disponíveis para todos os clientes
            </Subheader>

            {fields.map((field, i) => (
              <ConfigField
                key={field.uuid}
                name={field.name}
                type={field.type}
                optionsList={field.options}
                editable={field.created}
                onNameChange={(_, value) =>
                  presenter.onChange("name", i, value)
                }
                onTypeChange={(_, value) =>
                  presenter.onChange("type", i, value)
                }
                onOptionsChange={(_, value) =>
                  presenter.onChange("options", i, value)
                }
                onCheck={checked => presenter.onChange("required", i, checked)}
                options={CustomInfoModal.FieldType}
                required={field.required}
                onDelete={() => presenter.onDeleteField(i)}
              />
            ))}
            <hr />
            <Row>
              <Col>
                <StyledButton
                  secondary
                  leftIcon={<Icons>add</Icons>}
                  label="Adicionar"
                  onClick={() => presenter.handleCreateConfigField()}
                />
              </Col>
            </Row>
          </DialogContent>

          <DialogActions>
            <StyledButton
              flat
              label="Voltar"
              onClick={() => presenter.onClose()}
            />

            <StyledButton
              primary
              label="Concluir"
              onClick={() => presenter.onSendConfigField()}
            />
          </DialogActions>
        </Loadable>
      </Dialog>
    );
  }
}

export default CustomInfoModal;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/custom-fields/modal/view.jsx